<div id="detail-wrapper" [class.scrolling]="scrolling" #detailWrapper role="region" aria-label="contenuto-dettaglio">

  <app-transparent-administration-detail-body *ngIf="detailInformation" [detailInformation]="detailInformation"
    [parentData]="parentData" [id]="filename">
  </app-transparent-administration-detail-body>
</div>